module.exports = __webpack_public_path__ + "783c92a8001bf1c470414ca5d067d2ba.png";